import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Keep the sizing call sites while serving the original public Storage URL.
 * Supabase's render/image endpoint is not enabled for this project.
 */
export function optimizedSupabaseImage(
  url: string | null | undefined,
  _width: number,
  _height = _width,
) {
  return url;
}
